function CancellationPolicy(props) {
  return <>CancellationPolicy</>;
}

export default CancellationPolicy;
